import { formatDate } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
  IMAGE_SRC,
  NO_RESULTS,
} from 'src/app/components/shared/shared-constants';
import { PackageHistory } from 'src/app/core/models/package-tracking.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { PackageUtils } from 'src/app/core/utils/package/package.utils';
import { CONSTS } from '../package-tracking.constants';
import {
  EVENT_TYPES,
  EVENT_TYPE_CONSTS,
  EXCEL_FILE_NAME,
  PACKAGE_HISTORY,
  WARNING_TYPES,
} from './package-history.constants';
@Component({
  selector: 'app-package-history',
  templateUrl: './package-history.component.html',
  styleUrls: ['./package-history.component.scss'],
  standalone: false,
})
export class PackageHistoryComponent implements OnChanges {
  @Input() packageHistory?: PackageHistory;
  @Input() trackingNumber!: string;
  readonly CONSTANTS = {
    ...PACKAGE_HISTORY,
    ...EVENT_TYPE_CONSTS,
    ...CONSTS,
  };
  readonly IMAGES = IMAGE_SRC;
  readonly eventTypes = EVENT_TYPES;
  readonly NO_RESULTS = NO_RESULTS;
  readonly warningTypes = WARNING_TYPES;
  //FIX TYPES
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  historyEvents: any[] = [];
  //FIX TYPES
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warningBanners: any[] = [];

  constructor(
    private packageUtilsService: PackageUtils,
    private commonUtils: CommonUtils,
  ) {}

  ngOnChanges(): void {
    if (this.packageHistory) {
      this.historyEvents = [];
      Object.values(this.packageHistory).forEach((value) => {
        //Filter out an empty values
        if (value.length > 0) {
          this.historyEvents = [...this.historyEvents, ...value];
        }
      });

      this.historyEvents = this.packageUtilsService.getUniqueSortedEvents(
        this.historyEvents,
      );
    }
  }

  exportExcel(): void {
    const {
      addressValidationHistory = [],
      buildingScan = [],
      delivery = [],
      exception = [],
      handoverScan = [],
      intercept = [],
      manifestHistory = [],
      packageForecast = [],
      pickup = [],
    } = this.packageHistory || {};
    const addressValidationHistoryData =
      this.packageUtilsService.getCSVExportData(
        addressValidationHistory,
        this.trackingNumber,
      );

    const buildingScanData = this.packageUtilsService.getCSVExportData(
      buildingScan,
      this.trackingNumber,
    );
    const deliveryData = this.packageUtilsService.getCSVExportData(
      delivery,
      this.trackingNumber,
    );
    const exceptionData = this.packageUtilsService.getCSVExportData(
      exception,
      this.trackingNumber,
    );
    const handoverScanData = this.packageUtilsService.getCSVExportData(
      handoverScan,
      this.trackingNumber,
    );
    const interceptData = this.packageUtilsService.getCSVExportData(
      intercept,
      this.trackingNumber,
    );
    const manifestHistoryData = this.packageUtilsService.getCSVExportData(
      manifestHistory,
      this.trackingNumber,
    );
    const packageForecastModifyItems =
      this.packageUtilsService.normalizeObjectFields(packageForecast);

    const packageForecastData = this.packageUtilsService.getCSVExportData(
      [...packageForecastModifyItems],
      this.trackingNumber,
    );

    const pickupData = this.packageUtilsService.getCSVExportData(
      pickup,
      this.trackingNumber,
    );
    const addressValidationHistoryTable =
      this.packageUtilsService.getTableHeaderWithData(
        addressValidationHistory,
        addressValidationHistoryData,
        this.trackingNumber,
        'Address validation history',
      );
    const buildingScanTable = this.packageUtilsService.getTableHeaderWithData(
      buildingScan,
      buildingScanData,
      this.trackingNumber,
      'Building Scan',
    );
    const deliveryTable = this.packageUtilsService.getTableHeaderWithData(
      delivery,
      deliveryData,
      this.trackingNumber,
      'Delivery',
    );
    const exceptionTable = this.packageUtilsService.getTableHeaderWithData(
      exception,
      exceptionData,
      this.trackingNumber,
      'Exception Processing',
    );
    const handoverScanTable = this.packageUtilsService.getTableHeaderWithData(
      handoverScan,
      handoverScanData,
      this.trackingNumber,
      'Handover scan',
    );
    const interceptTable = this.packageUtilsService.getTableHeaderWithData(
      intercept,
      interceptData,
      this.trackingNumber,
      'Intercept',
    );
    const manifestHistoryTable =
      this.packageUtilsService.getTableHeaderWithData(
        manifestHistory,
        manifestHistoryData,
        this.trackingNumber,
        'Manifest History',
      );
    const packageForecastTable =
      this.packageUtilsService.getTableHeaderWithData(
        packageForecastModifyItems,
        packageForecastData,
        this.trackingNumber,
        'Package Forecast',
      );

    const pickupTable = this.packageUtilsService.getTableHeaderWithData(
      pickup,
      pickupData,
      this.trackingNumber,
      'Pickup',
    );
    const allTables = [
      ...(addressValidationHistory.length ? addressValidationHistoryTable : []),
      ...[[]],
      ...(buildingScan.length ? buildingScanTable : []),
      ...[[]],
      ...(delivery.length ? deliveryTable : []),
      ...[[]],
      ...(exception.length ? exceptionTable : []),
      ...[[]],
      ...(handoverScan.length ? handoverScanTable : []),
      ...[[]],
      ...(intercept.length ? interceptTable : []),
      ...[[]],
      ...(manifestHistory.length ? manifestHistoryTable : []),
      ...[[]],
      ...(packageForecast.length ? packageForecastTable : []),
      ...[[]],
      ...(pickup.length ? pickupTable : []),
    ];
    this.commonUtils.exportExcel([], EXCEL_FILE_NAME, allTables);
  }

  formatDateTime(dateTime: string) {
    const date = dateTime ? new Date(dateTime) : new Date();
    const formatedDate = formatDate(date, 'MMM d, y', 'en-US');
    const formatedTime = formatDate(date, 'H:mm:ss', 'en-US');
    return `${formatedDate} AT ${formatedTime}`;
  }
}
